import React from "react";

export const renderSuperscriptDagger = (value, keyPrefix = "dagger") => {
  const parts = String(value ?? "").split("†");

  return parts.map((part, index) => (
    <React.Fragment key={`${keyPrefix}-${part}-${index}`}>
      {part}
      {index < parts.length - 1 && <sup>†</sup>}
    </React.Fragment>
  ));
};
